import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const ModuleTextTicker = ({
    nextTypename,
    parent,
    previousTypename,
    text
}) => {
    // state
    const [ animationDuration, setAnimationDuration ] = useState(1);
    const [ textItems, setTextItems ] = useState([text]);

    // spacing
    let spacingClasses = [''];
    const zeroSpacedNextModules = new Set(['landing']);
    const zeroSpacedPreviousModules = new Set(['landing']);

    if (zeroSpacedNextModules.has(previousTypename)) {
        spacingClasses.push('pt-0 md:pt-0');
    } else {
        if (parent === 'Home') {
            spacingClasses.push('pt-40 md:pt-50');
        } else if (parent === 'Detail') {
            spacingClasses.push('pt-30 md:pt-30');
        } else {
            spacingClasses.push('pt-40 md:pt-60');
        }
    }

    if (zeroSpacedPreviousModules.has(nextTypename)) {
        spacingClasses.push('pb-0 md:pb-0');
    } else {
        if (parent === 'Home') {
            spacingClasses.push('pb-40 md:pb-50');
        } else if (parent === 'Detail') {
            spacingClasses.push('pb-30 md:pb-30');
        } else {
            spacingClasses.push('pb-40 md:pb-60');
        }
    }

    useEffect(() => {
        const handleResize = () => {
            const widthWidestChar = 14; // W char is 14px
            const widthText = text.length * widthWidestChar;
            const duplicateCount = Math.ceil(window.innerWidth / widthText);
            const widthLine = widthText * duplicateCount;

            setAnimationDuration((widthLine / 1440 * 100) * 0.05);
            setTextItems(Array(duplicateCount).fill(text));
        };

        handleResize();
        window.addEventListener('resize', handleResize, { passive: true });
        return () => window.removeEventListener('resize', handleResize);
    }, [ text ]);

    return (
        <div
            className={`relative overflow-hidden ${spacingClasses.join(' ')}`}
            inert=''>
            <div className={'bg-black w-screen max-w-screen left-1/2 relative -translate-x-1/2 whitespace-nowrap overflow-hidden'}>
                <ul
                    className='ticker text-white text-xs uppercase font-bold font-extended leading-3'
                    style={{ animationDuration: `${animationDuration}s` }}>
                    {textItems?.map((item, i) => {
                        return (
                            <li
                                className='mx-10 ticker__item inline-block'
                                key={i}>
                                {item}
                            </li>
                        );
                    })}
                </ul>

                <ul
                    className='ticker text-white text-xs uppercase font-bold font-extended leading-3'
                    style={{ animationDuration: `${animationDuration}s` }}>
                    {textItems?.map((item, i) => {
                        return (
                            <li
                                className='mx-10 ticker__item inline-block'
                                key={i}>
                                {item}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    nextTypename: PropTypes.string,
    parent: PropTypes.string,
    previousTypename: PropTypes.string,
    text: PropTypes.string
};

ModuleTextTicker.propTypes = propTypes;

export default ModuleTextTicker;
